import { Avatar } from '@zillow/constellation-10';
import AvatarGroupWrapper from './AvatarGroupWrapper';

export type AvatarGroupProps = {
  participants: Array<string>;
  variant?: 'default' | 'compact';
};

const MAX_AVATAR_COUNT = 3;

const AVATAR_STYLES = {
  default: {
    2: [
      { marginLeft: 0, top: '-8px', zIndex: 1 },
      { marginLeft: '-14px', top: '8px', zIndex: 2 },
    ],
    3: [
      { marginRight: '-18px', top: '-12px', zIndex: 1 },
      { marginLeft: '0px', top: '12px', zIndex: 2 },
      { marginLeft: '-6px', top: '-5px', zIndex: 3 },
    ],
  },
  compact: {
    2: [
      { marginLeft: 0, bottom: '10px', zIndex: 2 },
      { marginLeft: '-10px', bottom: '20px', zIndex: 1 },
    ],
    3: [
      { marginLeft: 0, bottom: '26px', zIndex: 1 },
      { marginLeft: '-10px', bottom: '20px', zIndex: 2 },
      { marginLeft: '-38px', bottom: '10px', zIndex: 3 },
    ],
  },
};

const AVATAR_SIZE = {
  default: {
    1: 'md',
    2: 'sm',
    3: 'xs',
  },
  compact: {
    1: 'xs',
    2: 'xs',
    3: 'xs',
  },
} as const;

export default function AvatarGroup({ participants, variant = 'default' }: AvatarGroupProps) {
  if (participants.length === 0) return null;

  const avatarNames = participants.slice(0, MAX_AVATAR_COUNT);
  const totalParticipants = participants?.length || 0;
  const avatarStyles = AVATAR_STYLES[variant][avatarNames.length as 2 | 3];
  const avatarSize = AVATAR_SIZE[variant][avatarNames.length as 1 | 2 | 3];

  if (totalParticipants >= 3) {
    return (
      <AvatarGroupWrapper>
        <Avatar fullName={avatarNames[0].toUpperCase()} size={avatarSize} style={avatarStyles[0]} />
        <Avatar fullName={avatarNames[1].toUpperCase()} size={avatarSize} style={avatarStyles[1]} />

        {totalParticipants > 3 ? (
          <Avatar size={avatarSize} style={avatarStyles[2]}>
            3+
          </Avatar>
        ) : (
          <Avatar fullName={avatarNames[2].toUpperCase()} size={avatarSize} style={avatarStyles[2]} />
        )}
      </AvatarGroupWrapper>
    );
  }

  if (totalParticipants === 2) {
    return (
      <AvatarGroupWrapper>
        {avatarNames.map((name, index) => (
          <Avatar key={name} fullName={name.toUpperCase()} size={avatarSize} style={avatarStyles[index]} />
        ))}
      </AvatarGroupWrapper>
    );
  }

  // Single participant
  return <Avatar fullName={avatarNames[0].toUpperCase()} size={avatarSize} />;
}
